import styled from "styled-components"

import {commonCSS} from "../common"
import {spacingCss, sizingCss} from "../../global/css"
import BodyProps from "./props"
import {mainStyles, regularStyles, smallStyles, largeStyles} from "./styles"

export default styled.p<BodyProps>`
  ${mainStyles}
  ${regularStyles} /* Default size, if no size prop is provided */

  ${({small}) => small && smallStyles}
  ${({large}) => large && largeStyles}

  ${commonCSS}
  ${spacingCss}
  ${sizingCss}
`
